// src/hooks/useThemeManager.js

import { useState, useEffect } from 'react';

// This helper function gets the initial theme. It hasn't changed.
const getInitialTheme = () => {
  if (typeof window === 'undefined') return 'dark';
  const savedTheme = localStorage.getItem('theme');
  if (savedTheme) return savedTheme;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

// This helper function applies the class to the <html> tag. It hasn't changed.
const applyTheme = (theme) => {
  if (typeof window === 'undefined') return;
  const root = document.documentElement;
  root.classList.remove('light', 'dark');
  root.classList.add(theme);
};

// --- The Updated Custom Hook ---

export const useThemeManager = () => {
  // 1. Initialize state with the correct theme
  const [theme, setTheme] = useState(getInitialTheme);

  // 2. This effect runs only once on mount to apply the initial theme class
  useEffect(() => {
    applyTheme(theme);
  }, []);

  // 3. This is the new, simplified toggle function
  const toggleTheme = () => {
    // Determine the new theme based on the current state
    const newTheme = theme === 'dark' ? 'light' : 'dark';

    // Update the React state to trigger a re-render in your components
    setTheme(newTheme);

    // Perform the "side effects": update localStorage and the <html> class
    localStorage.setItem('theme', newTheme);
    applyTheme(newTheme);
  };

  return { theme, toggleTheme };
};